<template>
    <main class="bg-white">
      <!-- Discover your path text section -->
      <div class="md:px-12 max-w-screen-2xl mx-auto py-4 mt-10">
        <h1 class="text-center text-lg font-black mt-10">Discover your Path</h1>
        <p class="text-center text-2xl mt-3">
          Unlock a world of opportunities with Barka U. Mshelia.
        </p>
        <p class="text-center text-2xl -mt-1">
          Whether you're looking to deepen your skills, ignite your business, or
          find inspiration, start here:
        </p>
      </div>
  
      <!-- Discover your path card section -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-0 mt-10">
        <!-- Person card -->
        <div
          v-for="(person, index) in persons"
          :key="index"
          class="group relative overflow-hidden"
        >
          <!-- Image -->
          <img
            :src="person.image"
            alt="person image"
            class="w-full h-full object-cover transition-transform duration-500 transform group-hover:scale-105"
          />
  
          <!-- Title inside image (at the bottom) -->
          <div
            class="absolute bottom-20 left-0 right-0 bg-black bg-opacity-50 text-[#ada595] font-extrabold text-lg text-center py-14 z-10 transition-opacity duration-500"
          >
            {{ person.title }}
          </div>
  
          <!-- Hover effect (description with transparent dark background) -->
          <div
          class="absolute inset-0 bg-black bg-opacity-70 flex items-center justify-center text-center text-white opacity-0 group-hover:opacity-100 duration-500 z-20 transform translate-x-full group-hover:translate-x-0 transition-transform"
        >
          <p class="px-4">{{ person.description }}</p>
        </div>
        </div>
      </div>
    </main>
</template>
  
<script>
export default {
  data() {
    return {
      persons: [
        {
          title: "MASTERCLASSES",
          image: require("../assets/images/crowd.jpeg"),
          description:
            "The Mshel Club: An exclusive mentorship circle by Barka U. Mshelia. Join now and enjoy the benefits of the Realestate community.",
        },
        {
          title: "KEYNOTE TALKS",
          image: require("../assets/images/mshel-club.jpeg"),
          description:
            "A renowned speaker who uses the power of storytelling and insight.",
        },
        {
          title: "MSHEL CLUB",
          image: require("../assets/images/brand.jpeg"),
          description:
            "A Growth Fund: Pioneering paths in venture capital, Mshel Group fuels the ambitions of next-gen entrepreneurs.",
        },
        {
          title: "RESOURCE LIBRARY",
          image: require("../assets/images/podcast.jpeg"),
          description:
            "School of Scale: A platform custom built to equip entrepreneurs looking to scale their businesses.",
        },
      ],
    };
  },
};
</script>

<style scoped>
/* Hover scale effect for image */
.group-hover\:scale-105 {
  transform: scale(1.05);
}

/* Smooth transition for the description and opacity */
.group-hover\:opacity-100 {
  opacity: 1;
}
.transition-opacity {
  transition: opacity 0.5s ease;
}
.transition-transform {
  transition: transform 0.5s ease;
}
</style>

  